import type { Invoice, InvoiceLine } from '@/types';

export const mockInvoices: Invoice[] = [
  {
    id: 'invoice-001',
    partner_id: 'partner-001',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0001',
    currency: 'EUR',
    subtotal: 1250,
    tax_rate: 21,
    tax_amount: 262.50,
    total: 1512.50,
    tax_treatment: 'vat_standard',
    status: 'paid',
    due_date: '2025-05-15',
    paid_at: '2025-05-10T10:00:00Z',
    payment_reference: 'BANK-REF-001',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-10T10:00:00Z'
  },
  {
    id: 'invoice-002',
    partner_id: 'partner-002',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0002',
    currency: 'USD',
    subtotal: 2850,
    tax_rate: 0,
    tax_amount: 0,
    total: 2850,
    tax_treatment: 'us_no_sales_tax',
    status: 'sent',
    due_date: '2025-05-20',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-01T00:00:00Z'
  },
  {
    id: 'invoice-003',
    partner_id: 'partner-003',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0003',
    currency: 'EUR',
    subtotal: 1125,
    tax_rate: 21,
    tax_amount: 236.25,
    total: 1361.25,
    tax_treatment: 'vat_standard',
    status: 'paid',
    due_date: '2025-05-15',
    paid_at: '2025-05-12T14:00:00Z',
    payment_reference: 'BANK-REF-003',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-12T14:00:00Z'
  },
  {
    id: 'invoice-004',
    partner_id: 'partner-003',
    period_start: '2025-05-01',
    period_end: '2025-05-15',
    invoice_number: 'LN-2025-0008',
    currency: 'EUR',
    subtotal: 525,
    tax_rate: 21,
    tax_amount: 110.25,
    total: 635.25,
    tax_treatment: 'vat_standard',
    status: 'sent',
    due_date: '2025-06-15',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-16T00:00:00Z',
    updated_at: '2025-05-16T00:00:00Z'
  },
  {
    id: 'invoice-005',
    partner_id: 'partner-001',
    period_start: '2025-05-01',
    period_end: '2025-05-15',
    invoice_number: 'LN-2025-0009',
    currency: 'EUR',
    subtotal: 625,
    tax_rate: 21,
    tax_amount: 131.25,
    total: 756.25,
    tax_treatment: 'vat_standard',
    status: 'sent',
    due_date: '2025-06-15',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-16T00:00:00Z',
    updated_at: '2025-05-16T00:00:00Z'
  },
  {
    id: 'invoice-006',
    partner_id: 'partner-004',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0004',
    currency: 'EUR',
    subtotal: 500,
    tax_rate: 21,
    tax_amount: 105,
    total: 605,
    tax_treatment: 'vat_standard',
    status: 'paid',
    due_date: '2025-05-15',
    paid_at: '2025-05-11T09:30:00Z',
    payment_reference: 'BANK-REF-004',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-11T09:30:00Z'
  },
  {
    id: 'invoice-007',
    partner_id: 'partner-005',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0005',
    currency: 'USD',
    subtotal: 475,
    tax_rate: 0,
    tax_amount: 0,
    total: 475,
    tax_treatment: 'us_no_sales_tax',
    status: 'paid',
    due_date: '2025-05-20',
    paid_at: '2025-05-13T11:00:00Z',
    payment_reference: 'BANK-REF-005',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-13T11:00:00Z'
  },
  {
    id: 'invoice-008',
    partner_id: 'partner-006',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0006',
    currency: 'USD',
    subtotal: 1110,
    tax_rate: 0,
    tax_amount: 0,
    total: 1110,
    tax_treatment: 'us_no_sales_tax',
    status: 'sent',
    due_date: '2025-05-20',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-01T00:00:00Z'
  },
  {
    id: 'invoice-009',
    partner_id: 'partner-002',
    period_start: '2025-05-01',
    period_end: '2025-05-15',
    invoice_number: 'LN-2025-0010',
    currency: 'USD',
    subtotal: 190,
    tax_rate: 0,
    tax_amount: 0,
    total: 190,
    tax_treatment: 'us_no_sales_tax',
    status: 'draft',
    due_date: '2025-06-20',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-16T00:00:00Z',
    updated_at: '2025-05-16T00:00:00Z'
  },
  // Goldman Realty (partner-002) — additional invoices
  {
    id: 'invoice-010',
    partner_id: 'partner-002',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0011',
    currency: 'USD',
    subtotal: 285,
    tax_rate: 0,
    tax_amount: 0,
    total: 285,
    tax_treatment: 'us_no_sales_tax',
    status: 'paid',
    due_date: '2025-05-20',
    paid_at: '2025-05-14T10:00:00Z',
    payment_reference: 'BANK-REF-002-A',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-14T10:00:00Z'
  },
  {
    id: 'invoice-011',
    partner_id: 'partner-002',
    period_start: '2025-03-01',
    period_end: '2025-03-31',
    invoice_number: 'LN-2025-0012',
    currency: 'USD',
    subtotal: 475,
    tax_rate: 0,
    tax_amount: 0,
    total: 475,
    tax_treatment: 'us_no_sales_tax',
    status: 'paid',
    due_date: '2025-04-20',
    paid_at: '2025-04-18T09:30:00Z',
    payment_reference: 'BANK-REF-002-B',
    pdf_url: null,
    created_at: '2025-04-01T00:00:00Z',
    updated_at: '2025-04-18T09:30:00Z'
  },
  // First Capital Lending (partner-005)
  {
    id: 'invoice-012',
    partner_id: 'partner-005',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0013',
    currency: 'USD',
    subtotal: 79,
    tax_rate: 0,
    tax_amount: 0,
    total: 79,
    tax_treatment: 'us_no_sales_tax',
    status: 'paid',
    due_date: '2025-05-20',
    paid_at: '2025-05-13T11:00:00Z',
    payment_reference: 'BANK-REF-005-A',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-13T11:00:00Z'
  },
  {
    id: 'invoice-013',
    partner_id: 'partner-005',
    period_start: '2025-05-01',
    period_end: '2025-05-15',
    invoice_number: 'LN-2025-0014',
    currency: 'USD',
    subtotal: 158,
    tax_rate: 0,
    tax_amount: 0,
    total: 158,
    tax_treatment: 'us_no_sales_tax',
    status: 'sent',
    due_date: '2025-06-15',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-16T00:00:00Z',
    updated_at: '2025-05-16T00:00:00Z'
  },
  // Texas PI Law Firm (partner-006)
  {
    id: 'invoice-014',
    partner_id: 'partner-006',
    period_start: '2025-04-01',
    period_end: '2025-04-30',
    invoice_number: 'LN-2025-0015',
    currency: 'USD',
    subtotal: 222,
    tax_rate: 0,
    tax_amount: 0,
    total: 222,
    tax_treatment: 'us_no_sales_tax',
    status: 'paid',
    due_date: '2025-05-20',
    paid_at: '2025-05-15T14:00:00Z',
    payment_reference: 'BANK-REF-006-A',
    pdf_url: null,
    created_at: '2025-05-01T00:00:00Z',
    updated_at: '2025-05-15T14:00:00Z'
  },
  {
    id: 'invoice-015',
    partner_id: 'partner-006',
    period_start: '2025-05-01',
    period_end: '2025-05-15',
    invoice_number: 'LN-2025-0016',
    currency: 'USD',
    subtotal: 333,
    tax_rate: 0,
    tax_amount: 0,
    total: 333,
    tax_treatment: 'us_no_sales_tax',
    status: 'sent',
    due_date: '2025-06-15',
    paid_at: null,
    payment_reference: null,
    pdf_url: null,
    created_at: '2025-05-16T00:00:00Z',
    updated_at: '2025-05-16T00:00:00Z'
  }
];

export const mockInvoiceLines: InvoiceLine[] = [
  { id: 'line-001', invoice_id: 'invoice-001', payout_line_id: 'payout-003', description: 'Legal lead - Van Dijk Legal - PI case Utrecht', amount_local: 125, amount_eur: 125 },
  { id: 'line-002', invoice_id: 'invoice-002', payout_line_id: 'payout-002', description: 'Real Estate lead - Goldman Realty - Buyer NYC', amount_local: 95, amount_eur: 88 },
  { id: 'line-003', invoice_id: 'invoice-003', payout_line_id: 'payout-008', description: 'PVC flooring lead - PVC Vloer Nederland - PVC click herringbone 45m2 Amsterdam', amount_local: 75, amount_eur: 75 },
  { id: 'line-004', invoice_id: 'invoice-003', payout_line_id: 'payout-009', description: 'PVC flooring lead - PVC Vloer Nederland - Laminate wide plank 32m2 Utrecht', amount_local: 75, amount_eur: 75 },
  { id: 'line-005', invoice_id: 'invoice-003', payout_line_id: 'payout-001', description: 'PVC flooring lead - PVC Vloer Nederland - PVC click plank 38m2 Amstelveen', amount_local: 75, amount_eur: 75 },
];
